module.exports = __webpack_public_path__ + "static/media/landing_0002_f.307a75b7.jpg";